const SIZES = {
    large: 48,
    medium: 34,
    small: 22
}

export { SIZES }